module.exports = __webpack_public_path__ + "img/puntoVenta.38701b65.svg";